import { neiLocalStorage } from '../config';

export function getNblyMicroServiceApiHeaders(): {[key: string]: any} 
{
    return {
        'Authorization': `Bearer ${neiLocalStorage.accessToken}`
    }
}